import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/geist";
import { App } from "./App";
import { AiConcierge } from "./AiConcierge";
import { ConnectPromotionPage, isConnectPromotionPath } from "./ConnectPromotionPage";
import { isPublicLandingHash, LandingPage } from "./LandingPage";
import { SessionProvider } from "./lib/session";
import { useSession } from "./lib/session";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SessionProvider>
      <RootExperience />
    </SessionProvider>
  </React.StrictMode>,
);

function RootExperience() {
  const { token, loading } = useSession();
  const [hash, setHash] = React.useState(window.location.hash);
  React.useEffect(() => { const update = () => setHash(window.location.hash); window.addEventListener("hashchange", update); return () => window.removeEventListener("hashchange", update); }, []);
  if (loading) return <div className="landing-loading" aria-label="Loading BlueDottedLine"><span /><span /><span /></div>;
  if (!token && isConnectPromotionPath(window.location.pathname)) return <><ConnectPromotionPage /><AiConcierge publicMode /></>;
  if (!token && isPublicLandingHash(hash)) return <><LandingPage /><AiConcierge publicMode /></>;
  return <><App /><AiConcierge /><footer className="application-build-footer" aria-label="Application release"><span>Build {import.meta.env.VITE_BUILD_NUMBER}</span><span>Copyright &copy; 2024&ndash;{new Date().getFullYear()} BlueDottedLine. All rights reserved.</span></footer></>;
}
